import { chain, contains, pluck } from 'underscore';
import { convertToMTFormat, Scopes } from '@bingads-webui-campaign-react/goal-selector';

export const viewModelToBulkModelForConversionGoals = (campaignViewModel, campaignId) => {
  const { conversionGoals } = campaignViewModel;
  return convertToMTFormat(
    campaignId,
    conversionGoals.goalScopeSelection,
    conversionGoals.originalConversionGoals,
    conversionGoals.goalSelection,
    true
  );
};

export const bulkModelToViewModelForConversionGoals = ({
  campaignModel,
  originalCampaignModel,
  errors = [],
}) => {
  const conversionGoalsBulkModel = campaignModel.CampaignConversionGoalAssociations;
  const errorKey = 'Client Id';
  const originalGoalSelection =
    chain(conversionGoalsBulkModel)
      .filter(goal => !contains(pluck(errors, errorKey), goal[errorKey]))
      .filter(goal => goal.Action === 'Add')
      .map(goal => ({
        Id: goal.GoalId,
      }))
      .value();
  return {
    conversionGoals: {
      ...originalCampaignModel.conversionGoals,
      originalConversionGoals: originalGoalSelection,
    },
  };
};

export const modelToViewModelForConversionGoals = (campaignModel) => {
  const hasCampaignLevelGoals = campaignModel.CampaignConversionGoal && campaignModel.CampaignConversionGoal.Goals
    && campaignModel.CampaignConversionGoal.Goals.length > 0;
  return {
    conversionGoals: {
      originalConversionGoals: campaignModel.CampaignConversionGoal.Goals,
      goalSelection: campaignModel.CampaignConversionGoal.Goals,
      goalScopeSelection: hasCampaignLevelGoals ?
        Scopes.CAMPAIGN : Scopes.ACCOUNT,
    },
  };
};
